import * as React from "react";

const ErrorCircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="m-1"
  >
    <path
      d="M9.75 11.15V5.15M9.75 14.25V14.15M9.75 18.75C14.7206 18.75 18.75 14.7206 18.75 9.75C18.75 4.77944 14.7206 0.75 9.75 0.75C4.77944 0.75 0.75 4.77944 0.75 9.75C0.75 14.7206 4.77944 18.75 9.75 18.75Z"
      stroke="#E70000"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ErrorCircleIcon;
